var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamHoverBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 21,
    viewBox: "0 0 104 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0C2.14307 3.52399 5.17534 6.6464 7.7036 8.79767C22.4101 9.05582 41.6527 14.4524 51.7165 20.1277V9.03534C33.5557 9.03534 16.1407 5.84736 0 0Z",
    fill: "url(#paint0_linear_318_5344)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.433 0C101.29 3.52399 98.258 6.6464 95.7297 8.79767C81.0232 9.05582 61.7806 14.4524 51.7168 20.1277V9.03534C69.8776 9.03534 87.2927 5.84736 103.433 0Z",
    fill: "url(#paint1_linear_318_5344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_5344",
    x1: 0,
    y1: 10.0638,
    x2: 51.7165,
    y2: 10.0638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_5344",
    x1: 77.573,
    y1: 0,
    x2: 77.573,
    y2: 20.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamHoverBottom);
export default __webpack_public_path__ + "static/media/team-hover-bottom.3450cc2069e9b8b0c96f85477c97ae3b.svg";
export { ForwardRef as ReactComponent };